import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import ContentLoader from 'react-content-loader'
import windowDimensions from 'react-window-dimensions'

import { ManualOffset } from './manualOffset'
import { PlayerControls } from './playerControls'

import { MusicSourceLogo as BaseMusicSourceLogo } from './utils/musicSourceLogo'

import Image from '../shared/image'
import Link from '../shared/link'

import { device } from '../../lib/deviceSizes'

import placeholderImage from '../../assets/images/placeholder-thumbnail.jpeg'

const Main = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 100%;
  width: 100%;
`

const LeftPanel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 35%;
  height: 100%;
`

const ContentLoaderContainerLeft = styled.div`
  position: absolute;
  top: 124px;
  left: 20px;

  width: 100%;
  max-width: 168px;
  margin: 8px 20px 0 0;

  @media ${device.xSmall} {
    top: 31vh;
    left: 3vw;
    max-width: 28vw;
  }
`

const CoverImageLink = styled(Link)`
  width: 80%;
  max-width: 380px;
  margin: 0 auto;
`

const CoverImage = styled(Image)`
  width: 100%;

  border-radius: 5px;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.2);
`

const MusicSourceLogo = styled(BaseMusicSourceLogo)`
  width: 60%;
  max-width: 180px;
  margin-top: 10px;
`

const RightPanel = styled.div`
  display: flex;
  flex-direction: column;

  height: 100%;
  width: 65%;
`

const ContentLoaderContainerRight = styled.div`
  position: absolute;
  top: 122px;
  left: 166px;

  max-width: 440px;
  width: 100%;
  margin: 4px 20px 0 0;

  @media ${device.xSmall} {
    top: 31vh;
    left: 28vw;
    max-width: 72vw;
  }

`

const NowPlaying = styled.div`
  margin-bottom: 5px;
  margin-top: 64px;

  color: #000000;
  font-family: ProximaNova-Bold;
  font-size: 16px;
  font-weight: 900;
  letter-spacing: normal;
  text-align: center;

  @media ${device.xSmall} {
    margin-top: 17vh;

    font-size: 2.5vw;
  }
`

const SongInfoContainer = styled.div`
  height: 33%;
`

const SongInfo = styled.div`
  color: #000000;
  font-family: ProximaNova-Regular;
  font-size: 24px;
  font-weight: 400;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media ${device.xSmall} {
    font-size: 4vw;
  }
`

const PlayerControlsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;
  top: 60px;

  width: 100%;

  @media ${device.xSmall} {
    top: 16vh;
  }

`

const renderLeftPanel = (props) => {
  if (props.song === undefined) {
    return (
      <LeftPanel>
        <ContentLoaderContainerLeft>
          <ContentLoader speed={3} width={166} height={380}>
            <rect x="0" y="0" rx="5" ry="5" width="166" height="166" />
            <rect x="28" y="180" rx="5" ry="5" width="110" height="30" />
          </ContentLoader>
        </ContentLoaderContainerLeft>
      </LeftPanel>
    )
  } else {
    return (
      <LeftPanel>
        {
          props.song.artwork_url &&
          <CoverImageLink url={props.song.source_url}>
            <CoverImage src={props.song.artwork_url} alt={props.song.title} errorPlaceholder={placeholderImage}/>
          </CoverImageLink>
        }
        <MusicSourceLogo source={props.song ? props.song.source : ''}/>
      </LeftPanel>
    )
  }
}

const renderRightPanelInfo = (props) => {
  return (
    <RightPanel>
      <SongInfoContainer>
        {((song) => {
          switch(song) {
          case undefined:
            return (
              <ContentLoaderContainerRight>
                <ContentLoader speed={3} width={434} height={380}>
                  <rect x="180" y="22" rx="5" ry="5" width="110" height="16" />
                  <rect x="125" y="52" rx="5" ry="5" width="220" height="22" />
                  <rect x="145" y="86" rx="5" ry="5" width="180" height="22" />
                </ContentLoader>
              </ContentLoaderContainerRight>
            )

          default:
            return (
              <div>
                <NowPlaying>
                  NOW PLAYING
                </NowPlaying>
                <SongInfo>{props.song.title}</SongInfo>
                <SongInfo>{props.song.artist}</SongInfo>
              </div>
            )
          }
        })(props.song)}
      </SongInfoContainer>
      <PlayerControlsContainer>
        {
          props.isOffsetViewOn === true
            ? <ManualOffset {...props} />
            : <PlayerControls {...props} />
        }
      </PlayerControlsContainer>
    </RightPanel>
  )
}

const SongInformationComponent = (props) => {
  return (
    <Main>
      { renderLeftPanel(props) }
      { renderRightPanelInfo(props) }
    </Main>
  )
}

const mapStateToProps = (state) => {
  return {
    isOffsetViewOn: state.isOffsetViewOn
  }
}

export const SongInformation = connect(mapStateToProps, null)(windowDimensions()(SongInformationComponent))



// WEBPACK FOOTER //
// ./src/components/player/songInformation.js